import { gql } from "@apollo/client";

export const SET_ORGANIZATION_PARAMETERS = gql`
  mutation SetOrganizationParameters(
    $values: JSONObject
    $enabled: JSONObject
  ) {
    setOrganizationParameters(values: $values, enabled: $enabled) {
      id
    }
  }
`;

export const SET_ORGANIZATION_INTEGRATIONS = gql`
  mutation SetOrganizationIntegrations(
    $where: OrganizationWhereInput!
    $values: JSONObject
    $enabled: JSONObject
  ) {
    setOrganizationIntegrations(
      where: $where
      values: $values
      enabled: $enabled
    ) {
      id
    }
  }
`;

const organizationParameters = {
  SET_ORGANIZATION_PARAMETERS,
  SET_ORGANIZATION_INTEGRATIONS,
};

export default organizationParameters;
